define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi",
	"csi/comm",
	"csi/locale",
	"csi/table/New",
	"csi/xml",
	"./ProductType"
], function(declare,_,csi,comm,locale,New,xml,ProductType) {

	return declare(New, {
		// Boolean: default New controller only adds one node - this controller may add many
		bUpdateParent: false,
		successMsg: "",

		// Boolean: validation is handled explicitly
		bValidate: false,

		toWriter: function() {
			// summary: create samples according to form and add to source
			this._skuUrls = this.writeSKUs();

		},

		_canNavigate: function() {
			// summary: disable Save & Go since action can create multiple samples
			return false;
		},

		writeSKUs: function() {
			// summary: create skus of selected color/sizes
			var w = this.m_writer;
			var fd = this.m_formData;
			var form = this.popupView;
			var prefix = fd.getFieldValue(xml.ATTR_NAME, true);
			var skus = [];
			var product = this.getParent();
			var parentType = product.$Type;

			// use view to get field value in case field is hidden
			var nameField = fd.getField(xml.ATTR_NAME);
			var nameHasExpr = (nameField && nameField.hasExpression());

			// see which SKUs already exist for the parent
			var existingSKUs = form.getExistingSKUs();
			var skusCreated = 0;
			var skusIgnored = 0;
			var self = this;

			var	createSkus = function(color, size) {
				// see if (color,size) is already taken - ignore check if parent is no-color, no-size
				var colorSize = form.getColorSKUHashKey(color,size);
				if (colorSize != form.noColorSizeKey && existingSKUs[colorSize]) {
					// this combination is already taken - no dups allowed
					skusIgnored ++;
					return;
				}

				// (color,size) will now be already taken - remember for next time
				existingSKUs[colorSize] = true;

				var type = (parentType == "Material" ? "SKUMaterial" : "SKU");
				var	url = comm.createUrl(type);

				// create new SKU node
				var cn = w.createNode(url, type);  // cn is a ChangeNode
				self.m_urlNode = url;
				self.toWriterFields(url, fd);

				// see if there is an expression on Node Name set by the Business Object - if so, ignore this next part
				if (nameField && !nameHasExpr) {
					//Found that any string in double quotes were resulting in error while evaluating expression.Added this unicode replacement to fix that.
					var exp = "\"" + prefix.replace(/\"/g,"\\u0022") + "\"";

					// populate size / color attributes
					if (color)
						exp += "+ \"-\" + RealizedColor.`Node Name`";

					if (size)
						exp += "+ \"-\" + RealizedSize.`Node Name`";

					// use one-time expression for Name
					cn.changeAttributeExp("Node Name", exp, true); // one time expr
				}

				cn.changeAttribute("RealizedColor", xml.ATTR_REF, color || csi.EMPTY_URL);
				cn.changeAttribute("RealizedSize", xml.ATTR_REF, size || csi.EMPTY_URL);
				cn.attach(self.m_urlParent, "RealizedProducts");

				// C8-10095 - call type-specific OnAction function to maintain any customized calls in the system
				self._onAction();
				self.m_urlNode = null;
				w.validateNode(url, true);

				// C8-14486 - flush changes in case there are expressions that are sequential
				w.flushChanges();

				skusCreated ++;
				skus.push(url);
			};

			// get selected sizes / colors
			var colorSizePairs = form.getSelectedColorSizePairs();
			colorSizePairs.forEach(function (colSizePair) {
				createSkus(colSizePair.c, colSizePair.s);
			});

			var gtin = fd.getFieldValue("AutoGTIN", true);
			if (gtin) {
				_.each(skus,function (skuUrl) {
				w.callMethod("SiteAdmin", "GlobalTradeItemAutoGenerateGTIN")
					.addParameter(xml.PROP_URL_PARENT, xml.ATTR_REF, this.m_urlParent)
					.addParameter(xml.PROP_URL, xml.ATTR_REF, skuUrl);
				});
			}

			// generate success message
			var msg = "";
			if (skusCreated == 1)
				msg += locale.resource("SKUCreated", [skusCreated]);
			if (skusCreated > 1)
				msg += locale.resource("SKUsCreated", [skusCreated]);

			if (skusIgnored > 0) {
				if (msg != "")
					msg += ", ";

				if (skusIgnored == 1)
					msg += locale.resource("SKUIgnored", [skusIgnored]);
				if (skusIgnored > 1)
					msg += locale.resource("SKUsIgnored", [skusIgnored]);
			}

			this.successMsg = msg;

			return skus;
		},

		getReturnNodeRequest: function(/*String[]*/urlsNew) {
			// summary: add new url to request
			if (!this._skuUrls)
				return this.inherited(arguments);
			return this.inherited(arguments, [urlsNew.concat(this._skuUrls)]);
		},

		getSuccess: function() {
			return this.successMsg;
		},

		getNewNodes: function() {
			return this.m_cache.getNodes(this._skuUrls);
		},

		postProcessSuccess: function() {
			// summary: add new nodes to form cache in case using Save & New - needed to support getExistingSKUs
			this.popupView.cacheView.cacheResponse(this.m_response);
			return this.inherited(arguments);
		},

		/**
		 * C8-10673 - return true if the popupView (form) "Use Matrix" is not active
		 * 			or if the group field is not RealizedColor or RealizedSize
		 */
		shouldApplyGroupValue: function(urlNode, id, spec) {
			var form = this.popupView;
			return (!form.isUsingMatrix() || (id != form.colorsLabel && id != form.sizesLabel));
		}
	});
});
